/**
 * 短剧管理 → 视角模板
 *
 * 子 Tab：
 * - 角色视角
 * - 物品视角
 * - 场景视角
 *
 * 这只是一个容器组件，不引入新业务逻辑；子组件维持原有职责与状态。
 */

import { useState } from 'react';
import { Sparkles } from 'lucide-react';

import DirectorAngleTemplatesTab from './DirectorAngleTemplatesTab';
import DirectorPropAngleTemplatesTab from './DirectorPropAngleTemplatesTab';
import DirectorSceneAngleTemplatesTab from './DirectorSceneAngleTemplatesTab';

type SubTab = 'character' | 'prop' | 'scene';

const SUB_TABS: Array<{ key: SubTab; label: string; icon: typeof Sparkles }> = [
  { key: 'character', label: '角色视角', icon: Sparkles },
  { key: 'prop', label: '物品视角', icon: Sparkles },
  { key: 'scene', label: '场景视角', icon: Sparkles },
];

export default function DirectorAngleTemplatesHubTab() {
  const [active, setActive] = useState<SubTab>('character');

  return (
    <div className="space-y-4">
      <div className="border-b border-light-border flex items-center gap-1 overflow-x-auto">
        {SUB_TABS.map((tab) => {
          const Icon = tab.icon;
          const activeFlag = active === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActive(tab.key)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeFlag
                  ? 'border-accent-blue text-accent-blue'
                  : 'border-transparent text-light-muted hover:text-light-text'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div>
        {active === 'character' && <DirectorAngleTemplatesTab />}
        {active === 'prop' && <DirectorPropAngleTemplatesTab />}
        {active === 'scene' && <DirectorSceneAngleTemplatesTab />}
      </div>
    </div>
  );
}
